import { render, staticRenderFns } from "./TwoColumnFlowLayout.vue?vue&type=template&id=5a4c1094&scoped=true"
import script from "./TwoColumnFlowLayout.vue?vue&type=script&lang=ts"
export * from "./TwoColumnFlowLayout.vue?vue&type=script&lang=ts"
import style0 from "./TwoColumnFlowLayout.vue?vue&type=style&index=0&id=5a4c1094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c1094",
  null
  
)

/* custom blocks */
import block0 from "./TwoColumnFlowLayout.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports